import React from "react";

interface CardProps {
  title: string;
  value: number;
  updatedTime: string;
  currency?: boolean;
}

const Card: React.FC<CardProps> = ({
  title,
  value,
  updatedTime,
  currency = false,
}) => {
  const formattedValue = new Intl.NumberFormat("en-US").format(value);

  return (
    <div
      className="flex flex-col items-center justify-center gap-4 rounded-[12px] bg-[#001854] p-3"
      style={{ boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.1)" }}
    >
      <h1 className="font-openSans font-bold text-[#FFFFFF]">{title}</h1>
      <h1 className="font-openSans text-[32px] font-bold text-[#FFFFFF]">
        {currency && <span className="text-[18px]">US$</span>}
        {formattedValue}
      </h1>
      <h1 className="mt-4 font-openSans text-[12px] font-normal italic text-[#A6A6A6]">
        Last updated on {updatedTime}
      </h1>
    </div>
  );
};

export default Card;
